import axios from 'axios'
import store from '@/store'

export const WEB_MAIN_PATH = '/web-main'

export function normalizePath(url) {
  if (!url || typeof url !== 'string') {
    return ''
  }
  const trimmed = url.trim()
  if (!trimmed) {
    return ''
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}

function firstLeafUnderRoot(root) {
  for (const sub of root.children || []) {
    for (const menu of sub.children || []) {
      if (menu?.url) {
        return menu
      }
    }
  }
  return null
}

export function pickLandingFromRoots(roots) {
  if (!Array.isArray(roots) || !roots.length) {
    return null
  }

  for (const root of roots) {
    if (normalizePath(root.url) === WEB_MAIN_PATH) {
      continue
    }
    const leaf = firstLeafUnderRoot(root)
    if (leaf?.url) {
      return {
        rootId: root.value,
        path: normalizePath(leaf.url)
      }
    }
  }

  for (const root of roots) {
    if (normalizePath(root.url) === WEB_MAIN_PATH) {
      return {
        rootId: root.value,
        path: WEB_MAIN_PATH
      }
    }
  }

  return null
}

export async function fetchAuthorizedMenuRoots() {
  const res = await axios.get('/user-api/mg-function/get-all-menu')
  return res.data?.code === 0 && Array.isArray(res.data.data) ? res.data.data : []
}

/**
 * 按角色授权菜单解析登录后默认落地页；优先业务模块，跳过首页仪表盘。
 */
export async function resolveDefaultLandingPath() {
  const roots = await fetchAuthorizedMenuRoots()
  const landing = pickLandingFromRoots(roots)
  if (landing) {
    store.commit('setRootMenu', landing.rootId)
    return landing.path
  }
  return null
}

export function userHasWebMainMenu(roots) {
  return Array.isArray(roots) && roots.some((root) => normalizePath(root.url) === WEB_MAIN_PATH)
}
